import { useQuery, useApolloClient } from '@apollo/client';
import { useState } from 'react';
import { getEntitySchema } from '../application/query';
import { ALL } from '../constants';

function useGetEntitySchema(identifier, skipCondition = false) {
  const client = useApolloClient();
  const [skip] = useState(!identifier || typeof identifier !== 'string' || skipCondition);
  let shouldSkip = skip;
  let cacheData = {};
  const variables = { identifier: identifier === ALL ? '' : identifier };
  if (!shouldSkip) {
    try {
      cacheData = client.readQuery({
        query: getEntitySchema,
        variables
      });
      shouldSkip = true;
    } catch (err) {
      shouldSkip = false;
    }
  }
  const { data = cacheData, loading, error } = useQuery(getEntitySchema, {
    variables,
    skip: shouldSkip
  });
  return { data, loading, error };
}
export default useGetEntitySchema;
